import { Icon, Tooltip } from '@chocolate-soup-inc/cs-frontend-components';
import _ from 'lodash';
import { TAlert } from '../../generated/graphql';

type TAlertsPropsType = {
  alerts: TAlert[];
};

export const AlertsTooltip = ({ alerts }: TAlertsPropsType) => {
  if (!alerts || !alerts.length) return <></>;
  const filteredAlerts = _.uniqBy(
    alerts.filter((a) => a && !a.acknowledgedAt),
    'message'
  );
  if (!filteredAlerts.length) return <></>;
  return (
    <Tooltip message={filteredAlerts.map((a) => a.message).join(' ')}>
      <Icon icon='warning' />
    </Tooltip>
  );
};
